module.exports = __webpack_public_path__ + "img/StivOld.0db13cdf.gif";